<div class="masked-icon">
    <mat-icon matSuffix (click)="onClickIcon()">{{ propertyValue.isMasked ? 'visibility_off' : 'visibility' }}</mat-icon>
</div>